import { computed, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Auth } from '@core/services';
import { UserRole } from '@core/interfaces/role.interface';

export const adminResellerGuard: CanActivateFn = () => {
  const authService = inject(Auth);

  const user = computed(() => authService.user || {});
  const isAdmin = computed(() => user().role?.name === UserRole.ADMIN);
  const isReseller = computed(() => user().role?.name === UserRole.RESELLER);

  if (!isAdmin() && !isReseller()) {
    authService.logout();
    return false;
  }

  return true;
};
